import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import useStore from '../Store/Store';

const SearchBox = ({ style, onChange }) => {
  const width = useStore((state) => state.screenWidth);
  return (
    <div
      style={{
        ...style,
        display: 'flex',
        width: width > 460 ? '300px' : '250px',
        padding: '8px 16px 8px 16px',
        gap: '8px',
        alignItems: 'center',
        flexWrap: 'nowrap',
        backgroundColor: '#ffffff',
        borderRadius: '100px',
        position: 'relative',
        margin: '0 auto',
      }}
    >
      <SearchIcon
        style={{
          width: '20px',
          height: '20px',
          flexShrink: '0',
          backgroundPosition: 'center',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          zIndex: '1',
          color: '#93939c',
        }}
      />
      <input
        type="text"
        placeholder="Search"
        style={{
          minWidth: '0',
          height: '24px',
          padding: '0 0 0 0',
          flexGrow: '1',
          flexShrink: '0',
          flexBasis: '0',
          fontFamily: 'Roboto, var(--default-font-family)',
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '24px',
          color: '#93939c',
          position: 'relative',
          textAlign: 'left',
          overflow: 'hidden',
          zIndex: '2',
          border: 'none',
        }}
        onChange={onChange}
      />
      <MicIcon
        style={{
          width: '20px',
          height: '20px',
          flexShrink: '0',
          backgroundPosition: 'center',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          zIndex: '4',
          color: '#93939c',
        }}
      />
    </div>
  );
};

export default SearchBox;
